export const UPDATE_BANNERS = 'UPDATE_BANNERS';

export const updateBanners = banners => ({
    type: UPDATE_BANNERS,
    banners
});
